/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    import IMaintenanceFormCustomButton = Meevo.Components.Controls.IMaintenanceFormCustomButton;

    export interface ISectionParamsMeevoMessengerSettings {
        sectionId: number;
        displayNameContentKey: string;
        template: string;
        isPrimarySection: boolean;
        handlesOwnCrud: boolean;
        baseEndpoint: string;
        sectionEndpoint: string;
        loggingService: Meevo.Components.Logging.ILoggingService;
        dataService: Meevo.Components.CommonClasses.ICommonDataService;
        context: MeevoMessengerSettingsContext;
        identityService: Meevo.Components.Common.IIdentityService;
        busyService: Meevo.Components.Busy.IBusyService;
        noun: Meevo.Model.NounEnum;
        sectionSecurityKey?: string;
    }

    interface IClassification {
        textel: string;
        arrivals: string;
        clientApp: string;
        twoWaySms: string;
    }

    export class MeevoMessengerSettingsContext extends Meevo.Components.CommonClasses.CommonContextBase {
        public sectionsSecurityKeysBase: Array<string> = [
            this.securityKeys.MANAGEMENT_MEEVOMESSENGER_MEEVOMESSENGERSETTINGS_ARRIVALSSETTINGS,
            this.securityKeys.INTEGRATION_CLIENTAPP_TAB_CLIENTAPPSETTINGS,
            this.securityKeys.INTEGRATION_TEXTEL_TAB_TEXTELSETTINGS
        ];
        private buttonsSet: Array<IMaintenanceFormCustomButton> = [{
            text: 'LABEL_INITIAL_SETUP',
            classNames: 'meevo-button-lg meevo-bottom-button',
            clickHandler: () => (<IMeevoMessengerSettingsTextelSection>this.selectedSection).initialSetup(),
            disableRules: () => false,
            visibilityRules: () => {
                if (this.selectedSection instanceof TextelSection && this.selectedSection.model) {
                    let isTokenExisted = this.isReadonly ? this.selectedSection.model.token : this.selectedSection['originalEntity'] && this.selectedSection['originalEntity'].token;
                    return !this.selectedSection.model.isAccountInitialized && !!isTokenExisted;
                }
            },
            securityRules: this.securityKeys.INTEGRATION_TEXTEL_TAB_TEXTELSETTINGS,
            position: 'left'
        }, {
            text: 'LABEL_DELETE_ACCOUNT',
            classNames: 'meevo-button-lg meevo-bottom-button',
            clickHandler: () => (<IMeevoMessengerSettingsTextelSection>this.selectedSection).deletePhoneNumber(() => this.setMode(Meevo.Model.MaintenanceFormState.Readonly)),
            disableRules: () => false,
            visibilityRules: () => {
                if (this.selectedSection instanceof TextelSection && this.selectedSection.model) {
                    return this.isEditing && this.selectedSection.model.isAccountInitialized;
                }
            },
            securityRules: this.securityKeys.INTEGRATION_TEXTEL_TAB_TEXTELSETTINGS,
            position: 'left'
        }];
        private readonly classification: IClassification  = {
            textel: 'Textel',
            arrivals: 'Arrivals',
            clientApp: 'MeGo',
            twoWaySms: 'Sms'
        };
        private readonly classificationParam: string = 'classification';

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $scope: angular.IScope,
            protected $filter: angular.IFilterService,
            protected $q: angular.IQService,
            protected $translate: angular.translate.ITranslateService,
            protected meevoMessengerSettingsService: IMeevoMessengerSettingsService,
            protected contextParams: any,
            protected $rootScope: angular.IRootScopeService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.meevoMessengerSettings;
            this.sectionTemplatePath = 'app/plugins/meevoMessengerSettings/sectionViews/';

            this.initializeSections();

            // initialEditSection: 'SECTION_TEXTEL'
        }

        initializeSections(): void {
            let baseSectionProps: ISectionParamsMeevoMessengerSettings = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: false,
                handlesOwnCrud: true,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                context: this,
                identityService: this.identityService,
                busyService: this.busyService,
                noun: Meevo.Model.NounEnum.Textel,
                sectionSecurityKey: ''
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_MEEVOMESSENGER_MEEVOMESSENGERSETTINGS_ARRIVALSSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ArrivalsSection(_.extend({}, baseSectionProps,
                    {
                        displayNameContentKey: 'SECTION_ARRIVALS',
                        template: 'arrivals.html',
                        isPrimarySection: true,
                        handlesOwnCrud: false,
                        sectionEndpoint: `setting?${this.classificationParam}=${this.classification.arrivals}`,
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_MEEVOMESSENGER_MEEVOMESSENGERSETTINGS_ARRIVALSSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    }), this.$filter, this.$translate, this.meevoMessengerSettingsService, this.modalService, this.$scope, this.$q));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_CLIENTAPP_TAB_CLIENTAPPSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ClientAppSection(_.extend({}, baseSectionProps,
                    {
                        displayNameContentKey: 'SECTION_ME_GO',
                        template: 'client_app.html',
                        isPrimarySection: true,
                        handlesOwnCrud: false,
                        sectionEndpoint: `setting?${this.classificationParam}=${this.classification.clientApp}`,
                        sectionSecurityKey: this.securityKeys.INTEGRATION_CLIENTAPP_TAB_CLIENTAPPSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    }), this.$filter, this.$translate, this.meevoMessengerSettingsService, this.modalService, this.$scope, this.$q, this.securityChecker));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_TEXTEL_TAB_TEXTELSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new TextelSection(_.extend({}, baseSectionProps,
                    {
                        displayNameContentKey: 'SECTION_TEXTEL',
                        template: 'textel.html',
                        isPrimarySection: true,
                        handlesOwnCrud: false,
                        sectionEndpoint: `setting?${this.classificationParam}=${this.classification.textel}`,
                        sectionSecurityKey: this.securityKeys.INTEGRATION_TEXTEL_TAB_TEXTELSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    }), this.$filter, this.$translate, this.meevoMessengerSettingsService, this.modalService, this.$scope, this.$q, this.$rootScope));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_TWOWAYSMS_TAB_TWOWAYSMSSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new TwoWaySmsSection(_.extend({}, baseSectionProps,
                    {
                        displayNameContentKey: 'SECTION_TWO_WAY_SMS',
                        template: 'twoWaySms.html',
                        isPrimarySection: true,
                        handlesOwnCrud: false,
                        sectionEndpoint: `setting?${this.classificationParam}=${this.classification.twoWaySms}`,
                        sectionSecurityKey: this.securityKeys.INTEGRATION_TWOWAYSMS_TAB_TWOWAYSMSSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    }), this.$filter, this.$translate, this.meevoMessengerSettingsService, this.modalService, this.$scope, this.$q));
            }

            this.preActivate(this.contextParams);
        }

        preActivate(contextParams: any): void {
            if (contextParams && contextParams.params && contextParams.params.initialEditSection) {
                const initialSection = contextParams.params.initialEditSection;
                const indexOfInitialSection = this.sections.findIndex(section => section.displayNameContentKey === initialSection);

                this.processActivate(indexOfInitialSection);
                return;
            }

            if (contextParams && contextParams.params && contextParams.params.convoInput) {
                const sectionName = MeevoMessengerHelperService.getSectionNameFromConvo(contextParams.params.convoInput);
                const indexOfInitialSection = this.sections.findIndex(section => section.displayNameContentKey === sectionName);

                this.processActivate(indexOfInitialSection);
                return;
            }

            if (!contextParams || !contextParams.params || !contextParams.params.initialEditSection || !contextParams.params.convoInput) {
                this.activate();
                return;
            }
        }

        processActivate(indexOfInitialSection) {
            if (indexOfInitialSection > -1){
                this.selectSection(this.sections[indexOfInitialSection]);
                this.initializeForEdit()
            } else {
                this.activate();
            }
        }



        initializeHeader(model: any): void {
            if (_.isFunction((<any>this.selectedSection).initializeHeader)) (<any>this.selectedSection).initializeHeader();
        }

        edit(): void {
            super.edit();

            if (_.isFunction((<any>this.selectedSection).edit)) (<any>this.selectedSection).edit();
        }

        cancel(): void {
            if (_.isFunction((<any>this.selectedSection).cancel)) (<any>this.selectedSection).cancel();

            return super.cancel();
        }

        selectSection(item): void {
            super.selectSection(item);
            const baseKey = item.sectionSecurityKey.replace(Meevo.Components.Common.SecurityParts.KEY_PART_READ, '');
            this.buildCrudSecurityKeysBase(baseKey);
        }

        save(): angular.IPromise<any> {
            if (_.isFunction((<any>this.selectedSection).save)) (<any>this.selectedSection).save();

            return super.save();
        }
    }
}
